/* eslint-env browser, jquery */

'use strict';

// disable right click on images
module.exports = {
  disabled(el) {
    $(el).on('contextmenu', 'img', e => this._prevent(e));
  },

  _prevent(/* e */) {
    // stopPropagation and preventDefault
    return false;
  },
};



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/contextmenu.js